import React from "react";
import { useParams } from "react-router-dom";
import { getStoreById } from "../ApiService";
import { useQuery } from "react-query";
import PageContainer from "../components/PageContainer/PageContainer";
import StoreSettings from "../modules/StoreSettings/StoreSettings";

const StorePage = () => {
  const { id } = useParams<{ id: string }>();
  const storeId = id as string;

  const { data: store } = useQuery(["store", id], () => {
    return getStoreById(storeId);
  });

  return (
    <PageContainer>{store && <StoreSettings store={store} />}</PageContainer>
  );
};
export default StorePage;
